import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Global } from "../../../Variables/Global";
import axiosInstance from '../../../api/axiosConfig';

const ManageDepartment = () => {
    var pId = useParams();
    var navigate = useNavigate();
     
    const [pageType, setPageType] = useState("Add");
    const [departmentName, setDepartmentName] = useState("");
    // const [companyId, setCompanyId] = useState(0);
    const [companies, setCompanies] = useState([]);

    const GetDepartment = (departmentId) => {
        var config = {
            method: 'get',
            url: "Department/GetDepartments/" + departmentId,
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': Global.Host
            },
        };

        axiosInstance(config)
            .then(function (response) {
                setDepartmentName(response.data.departmentName)
                document.title = response.data.departmentName;
                // setCompanyId(response.data.companyId)
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    // const GetCompanies = () => {
    //     var config = {
    //         method: 'get',
    //         url: "Company/GetCompany",
    //         headers: {
    //             'Content-Type': 'application/json',
    //             'Access-Control-Allow-Origin': Global.Host
    //         },
    //     };

    //     axiosInstance(config)
    //         .then(function (response) {
    //             setCompanies(response.data);
    //         })
    //         .catch(function (error) {
    //             console.log(error);
    //         });
    // }

    const submitForm = (e) => {
        e.preventDefault();
        if (IsValid()) {
            const body = { departmentName: departmentName, companyId: localStorage.getItem("C0m8N!"), logo: "" }
            if (pId.DepartmentId == "0") { //Add Department
                var config = {
                    method: 'post',
                    url: "Department/AddDepartment",
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': Global.Host
                    },
                    data: body
                };

                axiosInstance(config)
                    .then(function (response) {
                        if (response.status === 200) {
                            toast.success("Position Added Successfully")
                            navigate("/HR/Departments")
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                        toast.error("Something Went Wrong")
                    });
            }
            else { // Update Department
                var config = {
                    method: 'put',
                    url: "Department/EditDepartment/" + pId.DepartmentId,
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': Global.Host
                    },
                    data: body
                };

                axiosInstance(config)
                    .then(function (response) {
                        if (response.status === 200) {
                            toast.success("Department Updated Successfully")
                            navigate("/HR/Departments")
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                        toast.error("Something Went Wrong")
                    });
            }
        }
    }

    const IsValid = () => {
        if (departmentName == "") {
            toast.error("Enter Department Name");
            return false;
        }

        return true;
    }

    useEffect(() => {
        // GetCompanies();
        document.title = "Manage Department";
        if (pId.DepartmentId != "0") {
            setPageType("Edit");
            GetDepartment(pId.DepartmentId)
        }
    }, [])
    return (
        <>
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-6">
                            <div className="page-title-box">
                                <h4>Departments</h4>
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item"><a href="#">Mercator</a></li>
                                    <li className="breadcrumb-item"><Link to="/HR/Departments">Departments</Link></li>
                                    <li className="breadcrumb-item active">{pageType} Department</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="mb-3 row">
                                        <div className="col-12 col-md-6">
                                            <h4 className="card-title">{pageType} Department</h4>
                                        </div>
                                        <div className="col-12 col-md-6 text-right">
                                            <Link to="/HR/Departments" className="btn btn-secondary mr-3">Cancel</Link>
                                            <button className="btn btn-primary" onClick={(e) => submitForm(e)}>Submit</button>
                                        </div>
                                    </div>
                                    <div className="mb-3 row">
                                        <div className="col-md-6">
                                            <label className="col-md-6 col-form-label">Department Name</label>
                                            <input className="form-control" type="text" value={departmentName} onChange={(e) => setDepartmentName(e.target.value)} required />
                                        </div>
                                        {/* <div className="col-md-6">
                                            <label className="col-md-6 col-form-label">Company</label>
                                            <select className="form-control" value={companyId} onChange={(e) => setCompanyId(e.target.value)} required>
                                                <option value="0" key="0">-- Select Company Name --</option>
                                                {companies.length > 0 && (
                                                    companies.map((c, index) => {
                                                        return (<>
                                                            <option value={c.companyId} key={index}>{c.companyName}</option>
                                                        </>)
                                                    })
                                                )}
                                            </select>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
export default ManageDepartment;